/* eslint-disable promise/param-names */
import {AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT} from '../actions/auth';
import {USER_REQUEST} from '../actions/user';
import axios from "axios";

const state = {token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.statusCall
};

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    //todo:тут был промис, надо бы подучить нахрена
    return new Promise((resolve, reject) => {
      commit('setContent', 'Проверка данных, ожидайте');
      commit('showModal');
      user['action'] = 'tryLogin';
      //todo:url change dev/prod
      axios({
        method: 'post',
        url: process.env.VUE_APP_API_URL,
        data: user,
        responseType: 'json',
        headers: {'Content-type': 'application/json'}
      }).then(function (request) {
        try {
          if (request.data['Response']['ExecutionResult']['token'].length > 0) {
            localStorage.setItem('user-token', request.data['Response']['ExecutionResult']['token']);
            commit(AUTH_SUCCESS, request.data['Response']['ExecutionResult']);
            dispatch(USER_REQUEST);
            commit('hideModal');
            resolve();

          } else {
            commit(AUTH_ERROR, request.data['Response']['ExecutionError']['ExecutionErrorMessage']);
            localStorage.removeItem('user-token')
          }
        } catch (e) {
          console.log(e);
          try {
            commit('setContent', request.data['Response']['ExecutionError']['ExecutionErrorMessage']);
          } catch (e) {
            commit('setContent', 'Что то пошло не так');
          }
        }

      });

    });

  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem('user-token');
      resolve();
    })
  }
};

const mutations = {
  [AUTH_REQUEST]: (commit) => {
    //todo:хз зачем
    console.log(state);
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    //todo:кроме токена тоже хз как использовать
    state.status = 'success';
    state.token = resp.token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    //todo:вроде понятно, но...
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    //кристально ясно
    state.token = '';
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}
